import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../services/config.service';
import { BackupListComponent, BackupListDialogResult } from '../backup-list/backup-list.component';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { ManageBackupsDialogComponent, ManageBackupsDialogResult } from '../manage-backups-dialog/manage-backups-dialog.component';
import { UploadConfigComponent, UploadConfigDialogResult } from '../upload-config/upload-config.component';

@Component({
  selector: 'app-import-sheet',
  templateUrl: 'import-sheet.component.html',
  styleUrls: ['./import-sheet.component.css'],
})
export class ImportSheetComponent {
  constructor(private _configService: ConfigService, private _dialog: MatDialog, private _snackBar: MatSnackBar) {}

  getBackups() {
    this._configService.getBackupList().subscribe((data) => {
      this.openBackupLists('Listado de Backups de Configuración', 'Seleccione la configuración que desea cargar:', data)
        .afterClosed()
        .subscribe((result: BackupListDialogResult) => {
          if (result.load) this.loadConfigurationBackup(result.filename);
        });
    });
  }

  uploadConfig() {
    this.openUploadDialog('Subir configuración', 'Seleccione la configuración que desea subir al servidor:')
      .afterClosed()
      .subscribe((result: UploadConfigDialogResult) => {
        if (result.upload) this.uploadConfiguration(result.file);
      });
  }

  manageBackups() {
    this._configService.getBackupList().subscribe((data) => {
      this.openManageBackups('Listado de Backups de Configuración', 'Seleccione la(s) configuración(es) que desea eliminar:', data)
        .afterClosed()
        .subscribe((result: ManageBackupsDialogResult) => {
          if (result.delete) this.deleteConfigurationBackups(result.filesToDelete);
        });
    });
  }

  applyConfig() {
    this._dialog
      .open(DeleteDialogComponent, {
        data: {
          msg1: 'Atención',
          msg2: '¿Desea aplicar la configuración actual? Esta acción sobreescribirá el archivo config.json',
        },
      })
      .afterClosed()
      .subscribe((confirm) => {
        if (confirm) this.applyConfiguration();
      });
  }

  private openUploadDialog(title: string, message: string) {
    return this._dialog.open(UploadConfigComponent, {
      data: {
        title: title,
        message: message,
      },
    });
  }

  private openBackupLists(title: string, message: string, elements: string[]) {
    return this._dialog.open(BackupListComponent, {
      data: {
        title: title,
        message: message,
        elements: elements,
      },
    });
  }

  private openManageBackups(title: string, message: string, elements: string[]) {
    return this._dialog.open(ManageBackupsDialogComponent, {
      data: {
        title: title,
        message: message,
        elements: elements,
      },
    });
  }

  private loadConfigurationBackup(backupFilename: string) {
    this._configService.loadConfigBackup(backupFilename).subscribe(
      (laneConfig) => {
        this._configService.setCurrentConfig(laneConfig, true);
      },
      () => {
        this._snackBar.open('Error al cargar la configuración', '[ERROR]', { duration: 2000 });
      }
    );
  }

  private deleteConfigurationBackups(backupFiles: string[]) {
    this._configService.deleteConfigBackups(backupFiles).subscribe(
      (filesCount) => {
        this._snackBar.open(`Se han eliminado ${filesCount} elemento(s)`, 'OK', { duration: 2000 });
      },
      () => {
        this._snackBar.open('Error al eliminar los archivos de configuración', '[ERROR]', { duration: 2000 });
      }
    );
  }

  private uploadConfiguration(file: File) {
    this._configService.uploadConfiguration(file).subscribe(
      (laneConfig) => {
        this._configService.setCurrentConfig(laneConfig, true);
      },
      () => {
        this._snackBar.open('Error al subir el archivo de configuración', '[ERROR]', { duration: 2000 });
      }
    );
  }

  private applyConfiguration() {
    this._configService.applyConfiguration().subscribe(
      () => {
        this._snackBar.open('Configuración actualizada en la aplicación', 'Ok', { duration: 2000 });
      },
      () => {
        this._snackBar.open('Error al aplicar la configuración en la aplicación', '[ERROR]', { duration: 2000 });
      }
    );
  }
}
